<!--
 * @Description: 回显用户及回显数据内容组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-02-25 16:43:27
 * @LastEditTime: 2019-04-30 15:45:33
 -->
<template>
  <div class="data-main">
    <div class="user">
      <user
        :username="data.user.username"
        :orgName="data.user.orgname"
        :avatar="data.user.headPicUrl"
      />
    </div>
    <!--已读未读-->
     <read-people-modal
            :api="api"
            :taskid="readNumber[0].taskid"
            v-if="isShowReadModal"
            @modalCancel = "showReadModal"
        ></read-people-modal>
    <div class="banli" v-if="data.btnList">
      <div class="btnbox">
        <Button
          :loading="loading"
          size="small"
          type="primary"
          v-for="(item, index) in data.btnList"
          :key="index"
          @click="clickBtn(index)"
          style="margin-left: 20px"
        >{{item.btnname}}</Button>
      </div>

      <Form style="margin-top:30px">
        <FormItem label="已读：" v-if="readNumber.length">
           <div class="box"  @click="showReadModal">
              <div class="readnum">{{readNumber[0].value}}</div>
              <div class="iconfont icon-arrow iconright"></div>
            </div>
        </FormItem>
        <FormItem label="办理意见：">
          <Input v-model="context" placeholder="请输入办理意见" style="width: 500px" />
        </FormItem>
        <FormItem label="上传图片：">
          <div class="demo-upload-list" v-for="(item, index) in uploadList" :key="index">
            <template v-if="item.status === 'finished'">
              <img :src="item.url" />
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            multiple
            type="drag"
            :action="upLink"
            :headers="upHead"
            style="display: inline-block;width:58px;"
          >
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <Modal title="图片预览" v-model="visible">
            <img :src="imgName" v-if="visible" style="width: 100%" />
          </Modal>
        </FormItem>
        <FormItem label="同步至：" v-if="data.issync == 0">
          <Select v-model="selList" multiple style="width:500px;margin-left: 12px;" @on-change="syncChange" filterable>
            <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
         <select-people
            :peopleList="peopleList"
            labelWidth='70px'
            title='转派'
            :api="urlobj.getWorker"
            v-if="showZhuan"
            @modalCancel = "clickModal"
            @modalSelect = "zhuanpai_New"
            trTitle="转派至"
            >
            <div class="tr box">
              <div class="tr_title">办理积分</div>
              <Input
                  class="add-input"
                  placeholder="请输入.."
                  size="large"
                  type="number"
                  v-model="zhuanJf"
               />
            </div>
          </select-people>

      <Modal title="发布抢单" v-model="showQd" @on-ok="qiangdan">
        <Form>
          <FormItem label="办理积分">
            <Input
              v-model="qdJf"
              placeholder="请输入积分"
              type="number"
              style="width:300px"
            />
          </FormItem>
          <FormItem label="抢单人数">
            <Input
              v-model="qdNum"
              placeholder="请输入抢单人数"
              type="number"
              style="width:300px"
            />
          </FormItem>
          <FormItem label="发布至">
            <CheckboxGroup v-model="appType" style="margin-left: 60px">
              <Checkbox label="先锋e家"></Checkbox>
              <Checkbox label="民生通"></Checkbox>
            </CheckboxGroup>
          </FormItem>
        </Form>
      </Modal>
      <Modal title="转到其他社区" v-model="showShequ" @on-ok="zhuanShequ" width="700">
        <Form class="shequModal">
          <FormItem label="请选择">
            <Select v-model="shequ" style="width: 580px;" filterable>
              <Option v-for="item in shequList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
      </Modal>
    </div>
    <div class="content" v-else>
      <i-form style="margin-top:-3px">
        <row>
          <i-col span="16">
            <row>
              <FormItem label="已读：" v-if="readNumber.length" class="form-item">
                <div class="box" @click="showReadModal">
                    <div class="readnum">{{readNumber[0].value}}</div>
                    <div class="iconfont icon-arrow iconright"></div>
                  </div>
              </FormItem>
            </row>
            <row :gutter="10">
              <i-col span="12" v-for="(item,index) in showContent" :key="index">
                <form-item class="form-item" :label="`${item.label}：`">
                  <div class="form-item-content">
                    <!-- 默认的样式 -->
                    {{item.value}}
                  </div>
                </form-item>
              </i-col>
            </row>
            <row v-for="(item,index) in option" :key="index">
              <form-item v-if="option.length>0" :label="`${item.label}：`" class="form-item">
                <div class="form-item-content">{{item.value}}</div>
              </form-item>
            </row>
            <row>
              <form-item
                v-if="showFileContent!=null&&showFileContent.imgs"
                label="相关图片："
                class="form-item"
              >
                <div class="content-files">
                  <v-image
                    :img="item.fileurl"
                    v-for="item in showFileContent.imgs"
                    style="margin-right:10px"
                    :key="item.fileurl"
                  ></v-image>
                </div>
              </form-item>
            </row>
            <row>
              <form-item
                v-if="showFileContent!=null&&showFileContent.videos"
                label="相关视频："
                class="form-item"
              >
                <div class="content-files">
                  <video-item
                    v-for="(video,index) in showFileContent.videos"
                    :videosrc="video.fileurl"
                    style="margin-right:10px"
                    :delBtn="false"
                    :key="index"
                  ></video-item>
                </div>
              </form-item>
            </row>
            <row>
              <form-item
                v-if="showFileContent!=null&&showFileContent.files"
                label="相关附件："
                class="form-item"
              >
                <div class="content-files">
                  <v-file
                    :file="file"
                    v-for="(file,index) in showFileContent.files"
                    :key="index"
                    style="margin-right:10px"
                  />
                </div>
              </form-item>
            </row>
            <row>
              <form-item
                v-if="showFileContent!=null&&showFileContent.sounds"
                label="相关录音："
                class="form-item"
              >
                <div class="content-files">
                  <recording
                    :sound="sound"
                    v-for="(sound,index) in showFileContent.sounds"
                    :key="index"
                    class="sound"
                  />
                </div>
              </form-item>
            </row>
            <div
              v-if="data.delaycontent!=undefined&&data.delaycontent!=[]&&data.delaycontent.length>0"
              class="append"
            >
              <divider />
              <p>
                <icon custom="iconfont iconyinzhang" color="red" />延期审批
              </p>
              <row :gutter="10">
                <i-col span="12" v-for="(item,index) in data.delaycontent" :key="index">
                  <form-item :label="`${item.label}：`">{{item.value}}</form-item>
                </i-col>
              </row>
              <img
                :src="require('../../../assets/images/ok.png')"
                class="img"
                v-if="data.delaycontent.filter(item =>item.label=='mark')[0].value==0"
              />
              <img :src="require('../../../assets/images/no.png')" class="img" v-else />
            </div>

            <div
              v-if="data.backcontent!=undefined&&data.backcontent!=[]&&data.backcontent>0"
              class="append"
            >
              <divider />
              <p>
                <icon custom="iconfont iconyinzhang" color="red" size="20" />退回审批
              </p>
              <row :gutter="10">
                <i-col
                  span="12"
                  v-for="(item,index) in data.backcontent.filter(item =>item.label!='mark')"
                  :key="index"
                >
                  <form-item :label="`${item.label}：`">{{item.value}}</form-item>
                </i-col>
                <img
                  :src="require('../../../assets/images/ok.png')"
                  class="img"
                  v-if="data.backcontent.filter(item =>item.label=='mark')[0].value==0"
                />
                <img :src="require('../../../assets/images/no.png')" class="img" v-else />
              </row>
            </div>
          </i-col>
        </row>
      </i-form>
    </div>
  </div>
</template>
<script>
import selectPeople from "./selectPeople.vue";
import readPeopleModal from "./readPeopleModal.vue";
import User from "../../../components/User.vue";
import VImage from "../../../components/VImage.vue";
import VFile from "../../../components/VFile.vue";
import Recording from "../../../components/Recording.vue";
import VideoItem from "../../../components/VideoItem.vue";
import uploadImg from "../../../components/uploadImg.vue";
export default {
  props: {
    data: {
      type: Object
    },
    event: {
      type: Object
    },
    taskid: {
      type: String
    },
    communityId:{
      type:String
    }
  },
  data() {
    return {
      loading:false,//办理按钮loading
      context: "",
      imgName: "",
      visible: false,
      uploadList: [],
      defaultList: [],
      upLink: "",
      upHead: {},
      mTitle: "",
      zoneList: [],
      selList: [],
      showZhuan: false,
      zhuanJf: "",
      qyList: [],
      workerList: [],
      jmList: [],
      selZhuan: [],
      showQd: false,
      qdJf: "",
      qdNum: "",
      appType: [],
      sycnTitle: '',
      loading: false,
      peopleList:[],
      isShowReadModal:false,
      showShequ:false,
      shequList:[],
      shequ:'',
    };
  },
  components: {
    User,
    VImage,
    VFile,
    Recording,
    VideoItem,
    uploadImg,
    selectPeople,
    readPeopleModal,
  },
  methods: {
    showReadModal(){
      if(!this.api) this.api = this.urlobj.getReadPeople(this.readNumber[0].taskid)
      this.isShowReadModal = !this.isShowReadModal
    },
    handleView(item) {
      this.imgName = item.url;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      console.log(res);
      console.log(file);
      file.name = res.rows[0].filename;
      file.url = res.rows[0].filepath;
      this.$refs.upload.fileList;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "图片类型错误",
        desc: "图片 " + file.name + " 类型错误，请选择 jpg 或 png图片"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片大小超过限制",
        desc: "图片" + file.name + " 过大, 图片大小应小于2M."
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 5;
      if (!check) {
        this.$Notice.warning({
          title: "最多上传五张图片."
        });
      }
      return check;
    },
    syncChange(val){
      console.log(this.selList)
    },
    clickBtn(index) {
      //id 101办理 102转派 103发布抢单 20废弃 4驳回 1同意（核实节点）
      var id = this.data.btnList[index].id;
      
      switch (id) {
        case '22':
          console.log('11111111')
          this.showShequ = true
          break;
        case 101:
          
          if (this.uploadList.length > 0) {
            this.banli("data");
          } else {
            this.banli();
          }
          break;
        case 102:
          this.showZhuan = true;
          break;
        case 103:
          this.showQd = true;
          break;
        case "20":
          if (this.uploadList.length > 0) {
            this.feiqi("data");
          } else {
            this.feiqi();
          }
          break;
        case "4":
          if (this.uploadList.length > 0) {
            this.bohui("data");
          } else {
            this.bohui();
          }
          break;
        case "1" :
          console.log('heshi')
          if (this.uploadList.length > 0) {
            this.banli("data");
          } else {
            this.banli();
          }
          break;
      }
    },
    getXiaoqu() {
      var url = this.urlobj.getOrg();
      var data = {
        communityId: this.communityId,
        zoneType: 1 // 表示微社区和微支部
      };
      var mTitle;
      this.event.content.forEach(item => {
        if (item.name == "title") {
          mTitle = item.value;
        }
      });
      this.mTitle = mTitle;
      this.$get(url, data).then(res => {
        var list = [];
        var zoneList = res.rows.map(item => {
          return {
            name: item.zoneName,
            id: item.zoneId
          };
        });
        this.zoneList = [...list, ...zoneList];
      });
    },
    getPeople(type) {
      var url = this.urlobj.getWorker;
      var data = {
        communityId: this.communityId,
        pageNum: 0,
        pageSize: 0,
        queryType: type
      };
      return new Promise((resolve, reject) => {
        this.$get(url, data)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getZhuanList() {
      var getCompany = this.getPeople("company");
      var getResident = this.getPeople("resident");
      var getWorker = this.getPeople("worker");
      Promise.all([getCompany, getWorker, getResident]).then(res => {
        this.qyList = res[0].rows;
        (this.workerList = res[1].rows), (this.jmList = res[2].rows);
      });
    },
    zhuanChange(val) {
      console.log(val);
    },
    saveImg() {
      var file = this.uploadList.map(item => {
        return item.url;
      });
      var data = {
        taskid: this.taskid,
        files: file.join(",")
      };
      this.$get(this.urlobj.completeFile, data).then(res => {

        this.$Message.success("任务成功完成");
        this.$router.go(-1);
      });
    },
    banli(data) {
      if(this.context == ''){
        this.$Message.warning('请填写办理意见')
        return
      }
      this.loading = true
      var url = this.urlobj.completeMobile;

      let formData = new FormData();

      formData.append('taskId',this.taskid);
      formData.append('opinion',this.context);
      formData.append('coDestTaskUserIds',"");
      formData.append('extraVariables',JSON.stringify({ self: 1 }));
      formData.append('voteAgree',1);
     
      this.$post(url, formData).then(res => {
        this.addDxScore();
        if (data) {
          this.saveImg();
          if(this.selList.length > 0){
            this.syncNeighbour()
          }
          this.loading = false
        } else {
          if(this.selList.length > 0){
            this.syncNeighbour()
          }
          this.loading = false
          this.$Message.success(res.message);
          this.$router.go(-1);
        }
      });
    },

    //积分审核
    async addDxScore(){
      try {
       let url = this.urlobj.addDxScore;
        this.$get(url,{
          businesskey:this.$route.query.businesskey
        })
        .then(res => {
          if (!res.isSucceed) {
            this.$Modal.confirm({
              title: "提示",
              content: res.message
            });
          }
        })
      } catch (error) {
        console.error(error);
        
      }
    },
    feiqi(data) {
      if(this.context == ''){
        this.$Message.warning('请填写办理意见')
        return
      }
      this.loading = true
      var url = this.urlobj.endMobile;
      var data1 = {
        taskId: this.taskid,
        memo: this.context,
        coDestTaskUserIds: "",
        extraVariables: { self: 1 }
      };
      this.$get(url, data1).then(res => {
        if (data) {
          this.saveImg();
          this.loading = false
        } else {
          this.loading = false
          this.$Message.success("操作成功");
          this.$router.go(-1);
        }
      });
    },
    bohui(data) {
      if(this.context == ''){
        this.$Message.warning('请填写办理意见')
        return
      }
      this.loading = true
      var url = this.urlobj.completeMobile;

      let formData = new FormData();

      formData.append('taskId',this.taskid);
      formData.append('opinion',this.context);
      formData.append('coDestTaskUserIds',"");
      formData.append('extraVariables',JSON.stringify({ self: 1 }));
      formData.append('voteAgree',3);
      formData.append('back',1);

      this.$post(url, formData).then(res => {
        if (data) {
          this.saveImg();
          this.loading = false
        } else {
          this.loading = false
          this.$Message.success(res.message);
          this.$router.go(-1);
        }
      });
    },
    qiangdan() {
      var appType = this.appType;
      var arr = [];
      if (appType.length == 2) {
        arr = ["xfej", "mst"];
      } else {
        if (appType.indexOf("先锋e家") != -1) {
          arr = ["xfej"];
        } else if (appType.indexOf("民生通") != -1) {
          arr = ["mst"];
        } else {
          arr = [];
        }
      }
      if (arr.length == 0) {
        console.log("0");
        this.$Message.warning("请选择要发布的小程序");
        return;
      }
      if (this.qdJf == "" || this.qdJf <= 0) {
        console.log("02");
        this.$Message.warning("请填写正确的积分");
        return;
      }
      if (this.qdNum == "") {
        console.log("01");
        this.$Message.warning("请填写抢单人数");
        return;
      }
      this.loading = true
      var data = {
        type: 1,
        eventsId: this.$route.query.businesskey,
        score: this.qdJf * 100,
        limitNumber: this.qdNum,
        appType: arr.join(",")
      };
      this.$post(this.urlobj.qiangdan, data).then(res => {
        this.appType = [];
        this.qdJf = "";
        this.qdNum = "";
        if(this.selList.length > 0){
          this.syncNeighbour()
        }
        this.loading = false
        this.$Message.success("发布成功");
        this.$router.go(-1);
      });
    },
    //转给社区 确定
    zhuanShequ () {
      this.loading = true
      this.$post(this.urlobj.turnShequ,{
        communityId:this.shequ,
        eventId:this.$route.query.businesskey
      }).then(res => {
        this.loading = false
        this.$Message.success("转派成功");
        this.$router.go(-1);
      })
    },
    //打开或者关闭选择参会人
    clickModal(){
        this.showZhuan = !this.showZhuan
    },
    zhuanpai_New(data){
      console.log(data)
      this.peopleList = data
      this.showZhuan = false
      //判断用户所填信息
      if (this.context == "") {
        this.$Message.warning("请填写办理意见");
        return;
      }
      if (this.zhuanJf == "" || this.zhuanJf <= 0) {
        this.$Message.warning("请正确填写办理积分");
        return;
      }
      if (this.peopleList.length == 0) {
        this.$Message.warning("请选择转派对象");
        return;
      }
      let companyIdList = []//企业Id列表
      let selectPeopleList = [] //人员列表
      this.peopleList.forEach((item, index) => {
        //判断是否有企业
        if (item.type == "company") {
          companyIdList.push(item.id);
        } else {
          selectPeopleList.push(item);
        }
      });
      console.log(companyIdList)
       //转派至企业接口参数
      let data1 = {
        companyIdList,
        eventId: this.$route.query.businesskey
      };
      ///////
      let unionList = []
      let peopleIdList = []
      this.peopleList.forEach(item=>{
        if(item.type == 'company'){
          item.userList.forEach(_item=>{
            unionList.push(_item.unionId)
            peopleIdList.push("user^" + _item.uId + "^" + _item.userName)
          })
        }
      })
      selectPeopleList.forEach(item=>{
          unionList.push(item.unionId)
          peopleIdList.push("user^" + item.id + "^" + item.userName)
      })
      //jczl转派接口参数
      let data2 = {
        eventsId: this.$route.query.businesskey,
        score: this.zhuanJf * 100,
        unionId: unionList.join(",")
      };
      //bpm complete接口参数（转派用）

      let formData3 = new FormData();
      formData3.append('taskId',this.taskid);
      formData3.append('opinion',this.context);
      formData3.append('coDestTaskUserIds',idlist.join("#"));
      formData3.append('extraVariables',JSON.stringify({ self: 1 }));
      formData3.append('voteAgree',1);
      this.loading = true;
      if(this.uploadList.length > 0){
        this.zhuan(data1, formData3, 'file')
      }else {
        this.zhuan(data1, formData3)
      }
      this.$post(this.urlobj.eventRedeploy, data2).then(res => {
        if(this.selList.length > 0){
          this.syncNeighbour()
        }
      })
    },
    zhuanpai() {
      /**
       * 转派接口执行顺序
       * 1、如果选择了企业 先执行转派至企业接口（data1）同步调用bpm complete接口，后调用jczl转派接口
       * 2、如果未选择企业 调用bpm complete接口 jczl转派接口
       */
      this.zhuanJf;
      var list = [];
      var companyList = [];
      var cList = [];
      var pList = [];
      var cIdList = [];
      var pIdList = [];
      var uId = [];
      var list1 = [...this.workerList, ...this.jmList];
      //判断用户所填信息
      if (this.context == "") {
        this.$Message.warning("请填写办理意见");
        return;
      }
      if (this.zhuanJf == "" || this.zhuanJf <= 0) {
        this.$Message.warning("请正确填写办理积分");
        return;
      }
      if (this.selZhuan.length == 0) {
        this.$Message.warning("请选择转派对象");
        return;
      }
      this.loading = true;
      this.selZhuan.forEach((item, index) => {
        //判断是否有企业
        if (typeof item == "number") {
          companyList.push(item);
        } else {
          list.push(item);
        }
      });
      this.qyList.forEach((item, index) => {
        companyList.forEach((_item, _index) => {
          if (item.id == _item) {
            cList.push(this.qyList[index].userList);
          }
        });
      });
      //处理bpm接口所需的参数coDestTaskUserIds
      if (cList.length) {
        cList.forEach(item => {
          cIdList = item.map(_item => {
            return "user^" + _item.uId + "^" + _item.userName;
          });
        });
        cList.forEach(item => {
          uId = item.map(_item => {
            return _item.unionId;
          });
        });
      }
      list1.forEach((item, index) => {
        list.forEach((_item, _index) => {
          if (item.unionId == _item) {
            pList.push(list1[index]);
          }
        });
      });
      //处理bpm接口所需的参数coDestTaskUserIds
      pIdList = pList.map(item => {
        return "user^" + item.uId + "^" + item.userName;
      });
      //转派至企业接口参数
      var data1 = {
        companyIdList: companyList,
        eventId: this.$route.query.businesskey
      };
      var unionList = [...list, ...uId];
      //jczl转派接口参数
      var data2 = {
        eventsId: this.$route.query.businesskey,
        score: this.zhuanJf * 100,
        unionId: unionList.join(",")
      };
      var idlist = [...cIdList, ...pIdList];
      //bpm complete接口参数（转派用）

      let formData3 = new FormData();
      formData3.append('taskId',this.taskid);
      formData3.append('opinion',this.context);
      formData3.append('coDestTaskUserIds',idlist.join("#"));
      formData3.append('extraVariables',JSON.stringify({ self: 1 }));
      formData3.append('voteAgree',1);

      if(this.uploadList.length > 0){
        this.zhuan(data1, formData3, 'file')
      }else {
        this.zhuan(data1, formData3)
      }
      this.$post(this.urlobj.eventRedeploy, data2).then(res => {
        if(this.selList.length > 0){
          this.syncNeighbour()
        }
      })
    },
    zhuan(data1, data2, file) {
      if (data1.companyIdList.length > 0) {
        this.$post(this.urlobj.eventToCompany, data1).then(res => {
          this.$post(this.urlobj.completeMobile, data2).then(res => {
            if (file) {
              this.saveImg();
              this.loading = false
            } else {
              this.$Message.success("转派成功");
              this.loading = false;
              this.$router.go(-1);
            }
          }).catch(e => {
            this.loading = false;
          })
        }).catch(e => {
          this.loading = false;
        });
      } else {
        this.$post(this.urlobj.completeMobile, data2).then(res => {
          if (file) {
            this.saveImg();
          } else {
            this.$Message.success("转派成功");
            this.loading = false;
            this.$router.go(-1);
          }
        }).catch(e => {
          this.loading = false;
        });
      }
    },
    syncNeighbour(){
      this.selList.forEach(item => {
        var data = {
          comeId: item,//发布到所有微社区
          comeType: 1,
          message: this.sycnTitle,
          isTop: 0,
          linkId: this.$route.query.businesskey,
          linkType: 8
        }
        this.$post(this.urlobj.saveMessage, data).then(res => {
          this.loading = false
          console.log('success')
        }).catch(e => {
          this.loading = false
          console.log('shibai')
        })
      })
    },
    //获取社区列表 转派社区用
    getShequList () {
      this.$get(this.urlobj.zhuanShequ,{
        excludeSelf:1,
        communityId: this.communityId,
      }).then(res => {
        this.shequList = res.rows.map(item => {
          return {
            name:item.communityName,
            id:item.communityId
          }
        })
      })
    }
  },
  created() {
    // console.log(this.$route.query.businesskey)
    this.upLink = this.urlobj.uploadFile;
    this.upHead = {
      "X-Requested-With": "XMLHttpRequest",
      token: this.$store.state.access_token || ""
    };
  },
  mounted() {
    this.event.content.forEach(item => {
      if(item.name == 'title'){
        this.sycnTitle = item.value
      }
    })
    this.getXiaoqu();
    //this.getZhuanList();
    if (!this.data.btnList) {
      return;
    }
    this.uploadList = this.$refs.upload.fileList;
    this.getShequList()
  },
  computed: {
    readNumber() {
      let arr = this.data.content
        .filter(item => item.type == 'readNum')
      return arr;
    },
    //清除taskId和文件的内容
    showContent() {
      let obj = this.data.content
        .filter(item => item.value != undefined)
        .filter(item => item.label != "taskId")
        .filter(item => item.xtype != "textarea")
        .filter(item => item.type != "readNum")
      return obj;
    },
    //文件内容
    showFileContent() {
      let obj = this.data.content
        .filter(item => item.label != "taskId")
        .filter(item => item.value == undefined)[0];
      return obj;
    },
    //长文本内容
    option() {
      let obj = this.data.content
        .filter(item => item.value != undefined)
        .filter(item => item.label != "taskId")
        .filter(item => item.xtype == "textarea");
      return obj;
    }
  }
};
</script>
<style lang="less" scoped>
.data-main {
  display: flex;
  .user {
    width: 470px;
  }
  .content {
    width: calc(100% - 470px);

    .append {
      position: relative;
      p {
        width: auto;
        padding: 1px;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: red;
        margin-bottom: 10px;
      }
      img {
        position: absolute;
        left: 40%;
        top: 10px;
      }
    }
  }
  .banli {
    position: relative;
    width: calc(100% - 470px);
    .btnbox {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
    }
  }
  .form-item {
    margin-bottom: 0px;
    .form-item-content {
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
    }

    .state {
      color: #ff9600;
      font-size: 16px;
    }
    .content-files {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;
    }
    .sound {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
/deep/ .ivu-form-item {
  margin-bottom: 20px;
}
/deep/ .ivu-divider-horizontal {
  margin: 2px 0;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.zhuan-form {
  /deep/ .ivu-tag {
    background-color: #fff;
    border: 1px dashed #ff7b44;
  }
  /deep/ .ivu-icon-ios-close {
    background-color: #ff7b44;
    border-radius: 50%;
    color: #fff;
    transform: scale(1) !important;
    opacity: 1 !important;
  }
  /deep/ .ivu-tag-text {
    color: #ff7b44;
  }
}

.tr{
    line-height: 36px;
    .tr_title{
        margin-right: 20px;
        width: 60px;
    }
}
.add-input {
  margin-bottom: 10px;
}
/*已读未读*/
.readnum{
  color:#677a9e
}
.iconright{
  color:#677a9e;
  font-size: 14px;
}
  .shequModal{
    height: 300px;
  }
</style>
